export default "<spec-app-type8-timestamp-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type8-timestamp-table>\n";